export default __webpack_public_path__ + "4c2b05dbc31774c11394e6c0aa88cdec.png";